import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Skeleton from "@material-ui/lab/Skeleton";

import { useStyles } from "../Dashboard.css";
import { withRouter } from "react-router-dom";

class DashboardCard extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={4}
        xl={4}
        lg={4}
        className={classes.gridStyle}
        onClick={() => this.props.history.push(this.props.url)}
      >
        <Paper className={classes.paper}>
          <div className={classes.titleTextStyle}>
            <div>
              {this.props.icon ? this.props.icon : <CircularProgress />}
            </div>
            <div style={{ marginLeft: 10 }}>
              {this.props.label ? (
                this.props.label
              ) : (
                <Skeleton variant="text" />
              )}
            </div>
          </div>
          <Typography variant="h5" className={classes.textStyle}>
            <div className={classes.countStyle}>
              {this.props.count !== "" ? (
                this.props.count >= 0 && this.props.count
              ) : (
                <CircularProgress />
              )}
            </div>
          </Typography>
        </Paper>
      </Grid>
    );
  }
}

export default withRouter(withStyles(useStyles)(DashboardCard));
